/* src/app/shared/terms-and-conditions/components/terms-and-conditions-modal/terms-and-conditions-modal.component.scss */
.wrapper {
  margin: 2rem;
}
:host ::ng-deep .formio-component-submit {
  display: none;
}
/*# sourceMappingURL=terms-and-conditions-modal.component-QB466JM3.css.map */
